import { render, staticRenderFns } from "./course-icon.vue?vue&type=template&id=2959da26&"
import script from "./course-icon.vue?vue&type=script&lang=js&"
export * from "./course-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports